import { render } from "./ShopArrearsTwo.vue?vue&type=template&id=672ab620&scoped=true"
import script from "./ShopArrearsTwo.vue?vue&type=script&lang=js"
export * from "./ShopArrearsTwo.vue?vue&type=script&lang=js"

import "./ShopArrearsTwo.vue?vue&type=style&index=0&id=672ab620&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672ab620"]])

export default __exports__